var map = {
	"./views/error/403": [
		7129
	],
	"./views/error/403.vue": [
		7129
	],
	"./views/error/404": [
		8682
	],
	"./views/error/404.vue": [
		8682
	],
	"./views/layout": [
		2680,
		2680
	],
	"./views/layout/": [
		2680,
		2680
	],
	"./views/layout/index": [
		2680,
		2680
	],
	"./views/layout/index.vue": [
		2680,
		2680
	],
	"./views/system/activity/activity": [
		3335,
		3335
	],
	"./views/system/activity/activity.vue": [
		3335,
		3335
	],
	"./views/system/article/article": [
		9181,
		4472,
		2447
	],
	"./views/system/article/article.vue": [
		9181,
		4472,
		2447
	],
	"./views/system/article/articleComment": [
		5819,
		5819
	],
	"./views/system/article/articleComment.vue": [
		5819,
		5819
	],
	"./views/system/article/teacherArticle": [
		1849,
		4472,
		7227
	],
	"./views/system/article/teacherArticle.vue": [
		1849,
		4472,
		7227
	],
	"./views/system/center/center": [
		9346,
		9346
	],
	"./views/system/center/center.vue": [
		9346,
		9346
	],
	"./views/system/chapter/chapter": [
		1201,
		135,
		4099
	],
	"./views/system/chapter/chapter.vue": [
		1201,
		135,
		4099
	],
	"./views/system/chapter/chapterStudy": [
		7099,
		9480
	],
	"./views/system/chapter/chapterStudy.vue": [
		7099,
		9480
	],
	"./views/system/chapter/teacherChapter": [
		4552,
		135,
		9236
	],
	"./views/system/chapter/teacherChapter.vue": [
		4552,
		135,
		9236
	],
	"./views/system/classification/classification": [
		9043,
		9043
	],
	"./views/system/classification/classification.vue": [
		9043,
		9043
	],
	"./views/system/dataStatistics/dataStatistics": [
		3435,
		2032,
		3435
	],
	"./views/system/dataStatistics/dataStatistics.vue": [
		3435,
		2032,
		3435
	],
	"./views/system/dept/dept": [
		4855,
		4855
	],
	"./views/system/dept/dept.vue": [
		4855,
		4855
	],
	"./views/system/dict/dict": [
		4294,
		4294
	],
	"./views/system/dict/dict.vue": [
		4294,
		4294
	],
	"./views/system/forum/forum": [
		2741,
		2741
	],
	"./views/system/forum/forum.vue": [
		2741,
		2741
	],
	"./views/system/forum/forumAdmin": [
		6917,
		9298
	],
	"./views/system/forum/forumAdmin.vue": [
		6917,
		9298
	],
	"./views/system/forum/forumItem": [
		1535,
		1535
	],
	"./views/system/forum/forumItem.vue": [
		1535,
		1535
	],
	"./views/system/generate/generate": [
		3084,
		3084
	],
	"./views/system/generate/generate.vue": [
		3084,
		3084
	],
	"./views/system/homework/homework": [
		3444,
		3444
	],
	"./views/system/homework/homework.vue": [
		3444,
		3444
	],
	"./views/system/index": [
		6168,
		6168
	],
	"./views/system/index/": [
		6168,
		6168
	],
	"./views/system/index/index": [
		6168,
		6168
	],
	"./views/system/index/index.vue": [
		6168,
		6168
	],
	"./views/system/index/teacherIndex": [
		3091,
		2032,
		3091
	],
	"./views/system/index/teacherIndex.vue": [
		3091,
		2032,
		3091
	],
	"./views/system/log/loginLog": [
		5987,
		5987
	],
	"./views/system/log/loginLog.vue": [
		5987,
		5987
	],
	"./views/system/log/operLog": [
		9735,
		9735
	],
	"./views/system/log/operLog.vue": [
		9735,
		9735
	],
	"./views/system/login/login": [
		1727
	],
	"./views/system/login/login.vue": [
		1727
	],
	"./views/system/major/major": [
		6231,
		6231
	],
	"./views/system/major/major.vue": [
		6231,
		6231
	],
	"./views/system/menu/menu": [
		2755,
		2755
	],
	"./views/system/menu/menu.vue": [
		2755,
		2755
	],
	"./views/system/message/message": [
		3106,
		3106
	],
	"./views/system/message/message.vue": [
		3106,
		3106
	],
	"./views/system/notice/notice": [
		889,
		889
	],
	"./views/system/notice/notice.vue": [
		889,
		889
	],
	"./views/system/param/param": [
		3798,
		3798
	],
	"./views/system/param/param.vue": [
		3798,
		3798
	],
	"./views/system/post/post": [
		7021,
		7021
	],
	"./views/system/post/post.vue": [
		7021,
		7021
	],
	"./views/system/question/question": [
		4401,
		4401
	],
	"./views/system/question/question.vue": [
		4401,
		4401
	],
	"./views/system/role/role": [
		5908,
		5908
	],
	"./views/system/role/role.vue": [
		5908,
		5908
	],
	"./views/system/school/school": [
		7516,
		7516
	],
	"./views/system/school/school.vue": [
		7516,
		7516
	],
	"./views/system/student/student": [
		7542,
		7542
	],
	"./views/system/student/student.vue": [
		7542,
		7542
	],
	"./views/system/task/studyInfo": [
		3289,
		3289
	],
	"./views/system/task/studyInfo.vue": [
		3289,
		3289
	],
	"./views/system/task/task": [
		8846,
		8497,
		4266
	],
	"./views/system/task/task.vue": [
		8846,
		8497,
		4266
	],
	"./views/system/task/taskComment": [
		1309,
		1309
	],
	"./views/system/task/taskComment.vue": [
		1309,
		1309
	],
	"./views/system/task/taskStudent": [
		357,
		357
	],
	"./views/system/task/taskStudent.vue": [
		357,
		357
	],
	"./views/system/task/teacherTask": [
		3823,
		8497,
		557
	],
	"./views/system/task/teacherTask.vue": [
		3823,
		8497,
		557
	],
	"./views/system/teacher/teacher": [
		3990,
		3990
	],
	"./views/system/teacher/teacher.vue": [
		3990,
		3990
	],
	"./views/system/testP/teacherTest": [
		9336,
		9336
	],
	"./views/system/testP/teacherTest.vue": [
		9336,
		9336
	],
	"./views/system/testP/test": [
		5202,
		5202
	],
	"./views/system/testP/test.vue": [
		5202,
		5202
	],
	"./views/system/testP/testItem": [
		6677,
		6677
	],
	"./views/system/testP/testItem.vue": [
		6677,
		6677
	],
	"./views/system/testP/testStudent": [
		2498,
		2498
	],
	"./views/system/testP/testStudent.vue": [
		2498,
		2498
	],
	"./views/system/train/train": [
		534,
		7101,
		534
	],
	"./views/system/train/train.vue": [
		534,
		7101,
		534
	],
	"./views/system/user/user": [
		6769,
		6769
	],
	"./views/system/user/user.vue": [
		6769,
		6769
	],
	"./views/system/videoManage/videoManage": [
		9818,
		2032,
		7101,
		9818
	],
	"./views/system/videoManage/videoManage.vue": [
		9818,
		2032,
		7101,
		9818
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5378;
module.exports = webpackAsyncContext;